// Het onderwerp-filter (owner-review 2026-08-25: "is er een filter te maken
// voor regelgeving?").
//
// Ja — en er lag al meer klaar dan verwacht. `config/taxonomy/topics.yaml`
// deelt zijn 25 tags al in vier soorten in (regelgeving, technologie,
// standaard, markt) en die as werd nergens getoond (backlog 15). Eén menu met
// een kolom per soort: het kopje "Regelgeving" zet alle zeven tegelijk aan, en
// NIS2 los aanvinken kan ook.
//
// De lijst komt uit /api/meta — het scherm draagt geen eigen kopie
// (backlog 30: één as, één woordenlijst, één plek). Gedeeld door Skills en
// Trends, want beide tabellen dragen dezelfde tags.

import { FilterMenu } from "./FilterMenu";

/** De vier soorten uit topics.yaml, in de volgorde waarin ze op het scherm staan. */
const SOORTEN: { key: string; label: string; uitleg: string }[] = [
  {
    key: "regelgeving",
    label: "Regelgeving",
    uitleg:
      "Wetten en verordeningen die het werk veranderen: NIS2, de AI Act, de " +
      "Cyber Resilience Act, DORA, AVG/GDPR, de Data Act en DSA/DMA.",
  },
  {
    key: "technologie",
    label: "Technologie",
    uitleg: "Techniek die het werk verandert — van generatieve AI tot SBOM en DevOps.",
  },
  {
    key: "standaard",
    label: "Standaard",
    uitleg: "Raamwerken waarlangs vaardigheden worden beschreven, zoals ECSF en ETSI.",
  },
  {
    key: "markt",
    label: "Markt",
    uitleg:
      "Bewegingen in de markt zelf: halfgeleiders, supply chain, datacenters, " +
      "energietransitie, digitale soevereiniteit.",
  },
];

export type Onderwerp = { name: string; kind: string };

export function OnderwerpFilter({
  onderwerpen,
  gekozen,
  facet,
  eenheid,
  onChange,
}: {
  onderwerpen: readonly Onderwerp[];
  gekozen: string[];
  /** Aantal per tag, uit de facetten van de lijst. */
  facet: Record<string, number>;
  eenheid: string;
  onChange: (next: string[]) => void;
}) {
  const kolommen = SOORTEN.map((soort) => ({
    soort,
    tags: onderwerpen.filter((o) => o.kind === soort.key).map((o) => o.name),
  })).filter((k) => k.tags.length > 0);

  if (kolommen.length === 0) return null;

  return (
    <FilterMenu
      label="Onderwerp"
      note={
        "Waar gaat het over? Klik een kopje om die hele soort aan te zetten — " +
        `"Regelgeving" is dus één klik. Let op: niet elke ${eenheid.replace(/s$/, "")} ` +
        "draagt een onderwerp. Een tag is toegekend waar hij herkend werd, niet " +
        "overal waar hij geldt; filter je hierop, dan zie je alleen wat een tag " +
        "heeft. De aantallen per tag staan erbij."
      }
      sections={kolommen.map(({ soort, tags }) => ({
        key: soort.key,
        label: soort.label,
        uitleg: soort.uitleg,
        options: tags,
        values: gekozen.filter((g) => tags.includes(g)),
        counts: facet,
        allesTegelijk: true,
        onChange: (v: string[]) => {
          // De keuzes van de ándere soorten blijven staan.
          onChange([...gekozen.filter((g) => !tags.includes(g)), ...v]);
        },
      }))}
    />
  );
}
